<template>  
    <div>  
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<div class="stepForm" v-if="success == '3'">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{$t('reqProcessing')}}</h3>
            </div> 
           
        </div>
        <div class="stepForm" v-if="success == true">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{ $t('reqVerify') }}</h3>
            </div> 
            <div class="CustomBlockWidth inMiddle-area whitebox p-4">  
                <div class="congratulations">
                    <div class="logo_congrats">
                        <img src="../../../../static/fxView/images/check.svg" alt="Request Verify">
                    </div>
                    <div class="subtitle">
                        <h3>{{ $t('dear') }} <span class="green">{{get_user.username}}</span></h3>
                        <p>{{ $t('bonusVerMsz1') }}</p>
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                        <router-link :to="'/bonus-list'" class="prism_btn btn_sm">{{ $t('backBonusList') }}</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="stepForm" v-if="success == false">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{ $t('reqFailed') }}</h3>
            </div> 
            <div class="CustomBlockWidth inMiddle-area whitebox p-4">  
                <div class="congratulations">
                    <div class="logo_congrats">
                        <img src="../../../../static/fxView/images/cross.svg" alt="Request Failed">
                    </div>
                    <div class="subtitle">
                         <h3>{{ $t('dear') }} <span class="green">{{get_user.username}}</span></h3>
                         <p>{{msg}}</p>
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                        <router-link :to="'/bonus-list'" class="prism_btn btn_sm">{{ $t('backBonusList') }}</router-link>
                    </div>
                </div>
            </div> 
        </div>
    </div> 
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'bonus',
        mixins: [fxViewMixins],
        data() {
            return {
                verify : '',
                success : '3',
                msg : '',
                pageLoader : false,
                response_msg : '',
                msg_type : '',
				type : ''
            }
        },
        created(){
            let query = Object.assign({}, this.$route.query);
            if(this.$route.query.verify){
                this.verify = query.verify
				this.type = query.type
				
				let input_json = {
                    'globalParams' : {
                        'verify' : this.verify.toString()
                    } ,'localParams' : {'parameter' : this , 'params' :'request-verify'}
                }
				
				if(this.type == 'REMOVE_BONUS'){
                    this._runRemoveBonus(input_json)
                }else{
                    this._runBonusCheckOtp(input_json)
                }
                
                delete query.verify;
				delete query.type;
                this.$router.replace({ query });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/bonus/bonus_verify.vue